@if (!headerPod().hidePodHeader) {
    <ms-top-events-pod-header
        [class.pod-header-expand]="headerPod().isExpanded"
        [class.has-meta-title]="hasMetaData()"
        [pod]="headerPod()"
        [index]="index"
        (toggleExpansion)="toggleExpanded.set(!headerPod().isExpanded)" />
}

<ms-top-events-pod-body *rxIf="headerPod().isExpanded; renderCallback: render$; strategy: renderStrategy$" [pod]="pod()" [index]="index" />
